//	E X P O R T   L I B

export const lib_names = {
	endpoints: {
		media_deliver: 'https://pub-3690114e3d584c949bcf8cc3932fc27a.r2.dev/',
		server_api: 'https://server.linktomenu.it/public/',
	},
}